import { useIwocaPayApplication } from '../../hooks/useIwocaPayApplication';
import { SpendingLimitDrawer } from '../SpendingLimitDrawer/SpendingLimitDrawer';

export function AccountSpendingLimitDrawer({
  isSpendingLimitDrawerOpen,
  setIsSpendingLimitDrawerOpen,
  loadingRefreshSpendingLimit,
  refreshSpendingLimitErrorMessage,
  handleRefreshSpendingLimit,
}: {
  isSpendingLimitDrawerOpen: boolean;
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loadingRefreshSpendingLimit: boolean;
  refreshSpendingLimitErrorMessage: string | null;
  handleRefreshSpendingLimit: () => Promise<void>;
}) {
  const iwocaPayApplication = useIwocaPayApplication();

  return (
    <SpendingLimitDrawer
      isOpen={isSpendingLimitDrawerOpen}
      setIsOpen={setIsSpendingLimitDrawerOpen}
      refreshSpendingLimit={handleRefreshSpendingLimit}
      loadingRefreshSpendingLimit={loadingRefreshSpendingLimit}
      errorMessage={refreshSpendingLimitErrorMessage}
      application={iwocaPayApplication}
    />
  );
}
